import { useState } from 'react';
import { refreshPaperPreviewWatchlist } from '../../services/watchlistApi';
import type { AIStockData } from '../../types/watchlist';

export default function PaperWatchlistPreviewPanel() {
  const [stocks, setStocks] = useState<AIStockData[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [refreshedAt, setRefreshedAt] = useState<string | null>(null);

  const handleRefresh = async () => {
    if (!window.confirm('Paper 후보 미리보기를 새로 생성하시겠습니까? Gemini 호출 한도를 사용합니다.')) return;
    setLoading(true);
    setError(null);
    try {
      const result = await refreshPaperPreviewWatchlist();
      setStocks(result.full_data?.recommendations || []);
      setRefreshedAt(result.refreshed_at || null);
    } catch (err: any) {
      setError(err.message || 'Paper 후보 미리보기 실패');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ai-watchlist-panel">
      <div className="panel-header">
        <h3>Paper 후보 미리보기 (주문 영향 없음)</h3>
        <div className="panel-actions">
          <div className="countdown">{refreshedAt ? `preview: ${refreshedAt}` : 'preview not loaded'}</div>
          <button onClick={handleRefresh} disabled={loading}>
            {loading ? '생성 중...' : '새 프롬프트로 후보 생성'}
          </button>
        </div>
      </div>
      <div className="rate-limit-warning">
        <div className="warning-header">LIVE와 분리된 확인 경로</div>
        <div className="warning-content">
          <p>• 이 결과는 현재 화면 미리보기이며 Toss live universe를 바꾸지 않습니다.</p>
          <p>• live 주문 후보는 계속 Toss 검증 universe만 사용합니다.</p>
        </div>
      </div>
      {error ? <div className="error">{error}</div> : null}
      {stocks.length ? <PreviewList stocks={stocks} /> : <div className="empty">아직 생성한 preview가 없습니다</div>}
    </div>
  );
}

function PreviewList({ stocks }: { stocks: AIStockData[] }) {
  return (
    <div className="system-table">
      <table>
        <thead>
          <tr><th>종목</th><th>섹터</th><th>신뢰도</th><th>셋업</th><th>근거</th></tr>
        </thead>
        <tbody>
          {stocks.map((stock) => (
            <tr key={stock.ticker}>
              <td><strong>{stock.ticker}</strong></td>
              <td>{stock.sector || '-'}</td>
              <td>{stock.confidence ?? '-'}</td>
              <td>{(stock.setup_tags || []).join(', ') || '-'}</td>
              <td>{stock.why_now || stock.catalyst || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
